import Swiper from "./swiper-bundle.esm.browser.min.js";

if (!customElements.get("secondary-nav")) {
  customElements.define(
    "secondary-nav",
    class SecondaryNav extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.container = this.querySelector(".secondary-navigation");
        this.swiperEl = this.querySelector(".swiper");
        this.prevEl = this.querySelector(".swiper-button-prev");
        this.nextEl = this.querySelector(".swiper-button-next");
        this.dataCenterSlides = this.dataset.centerSlides === "";

        if (!this.swiperEl) return;
        this.initSwiper();
      }

      initSwiper() {
        const scrollToActiveSlide = (swiperEvent) => {
          const activeClass = "secondary-navigation__swiper-slide--active";
          const slides = [...swiperEvent.slides];
          const activeSlideIndex = slides.findIndex((el) =>
            el.classList.contains(activeClass),
          );
          if (activeSlideIndex > 0) {
            swiperEvent.slideTo(activeSlideIndex, 0, false);
          }
        };

        const centerSlides = (swiperEvent) => {
          const shouldBeCentered =
            swiperEvent.snapGrid.length === 1 && swiperEvent.snapGrid[0] === -0;
          swiperEvent.wrapperEl.classList.toggle(
            "secondary-navigation__swiper-wrapper--center",
            shouldBeCentered,
          );
        };

        this.swiper = new Swiper(this.swiperEl, {
          loop: false,
          slidesPerView: "auto",
          spaceBetween: 0,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          init: false,
          navigation: {
            nextEl: this.nextEl,
            prevEl: this.prevEl,
          },
        });

        this.swiper.on("afterInit", scrollToActiveSlide);
        if (this.dataCenterSlides) {
          this.swiper.on("init", centerSlides);
          this.swiper.on("resize", centerSlides);
        }

        this.swiper.init();
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
      }
    },
  );
}
